import { useEffect, useState } from "react"
import { getStoredUser } from "../auth/session"
import { avatarCdnUrl } from "@cookies/shared/cdn"
import { Panel } from "../components/ui"
import { fmtCompact, fmtInt, toNum } from "../game/format"
import { useBakeryStore } from "../game/bakeryStore"

export default function ProfilePage() {
  const user = getStoredUser()
  const store = useBakeryStore()
  const snap = store.snapshot
  const connected = store.connected
  const isLive = connected && snap?.me != null
  const url = user ? avatarCdnUrl(user.id, user.avatar ?? "", 64) : ""
  const [failed, setFailed] = useState(false)
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    if (!url || failed || loaded) return
    const t = window.setTimeout(() => setFailed(true), 1000)
    return () => window.clearTimeout(t)
  }, [url, failed, loaded])
  return (
    <div className="cb-page">
      <Panel className="hl center">
        {url && !failed ? (
          <img src={url} alt={user?.username ?? "Baker"} width={64} height={64} crossOrigin="anonymous" style={{ width: 64, height: 64, borderRadius: "50%", objectFit: "cover" }} onLoad={() => setLoaded(true)} onError={() => setFailed(true)} />
        ) : (
          <div className="cb-big-ava">👨‍🍳</div>
        )}
        <h2 className="cb-h">{user?.username ?? "Baker"}</h2>
        <p className="dim small" style={{ margin: 0 }}>
          {user ? "Signed in with Discord" : "Not signed in"} · <span className="cb-online"><i />Online</span>
        </p>
      </Panel>
      {!isLive && (
        <div className="cb-panel center small" role="status">
          Live bakery stats appear here once you join a bakery.
        </div>
      )}
      <div className="cb-cols">
        <Panel>
          <small className="dim">Total Cookies</small><div><b>🍪 {isLive ? fmtCompact(snap.bakery.cookies) : fmtInt(0)}</b></div>
          <small className="dim">Baker Credits</small><div><b>🪙 {isLive ? fmtInt(store.liveCredits) : fmtInt(0)}</b></div>
          <small className="dim">Contribution</small><div><b>📦 {isLive ? fmtCompact(snap.players.find((p) => p.userId === user?.id)?.contribution ?? "0") : fmtInt(0)}</b></div>
          {isLive && <small className="dim">Click power +{toNum(snap.me.clickPower) || 1}</small>}
        </Panel>
        <Panel>
          <h3 className="cb-sec on-light">Specialisation Perks</h3>
          <p className="dim small" style={{ margin: 0 }}>{isLive ? `Baking in Lv. ${snap.bakery.level} bakery` : "Pick a specialization from a live bakery to unlock perks."}</p>
        </Panel>
      </div>
    </div>
  )
}
